import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobSiteEstimateActions'
import * as api from '../../api/job/jobSiteEstimates'

export function* jobSiteEstimatesRefresh(action) {
  try {
    const payload = yield call(api.getJobSiteEstimates, action.jobId)
    yield put({ type: constants.JOB_SITE_ESTIMATES_REFRESH.SUCCESS, payload })
    action.next && action.next(null, payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_ESTIMATES_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobSiteEstimates() {
  yield takeLatest(constants.JOB_SITE_ESTIMATES_REFRESH.ACTION, jobSiteEstimatesRefresh)
}

function* sagaCreateJobSiteEstimate(action) {
  try {
    const payload = {
      content: action.content,
      estimateSections: action.estimateSections,
      jobId: action.jobId,
      userId: action.userId
    }
    yield call(api.createJobSiteEstimate, payload)
    yield put({ type: constants.JOB_SITE_ESTIMATE_CREATE.SUCCESS, payload })
    yield call(jobSiteEstimatesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_ESTIMATE_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobSiteEstimate() {
  yield takeLatest(constants.JOB_SITE_ESTIMATE_CREATE.ACTION, sagaCreateJobSiteEstimate)
}

function* sagaUpdateJobSiteEstimate(action) {
  try {
    const payload = {
      estimateId: action.estimateId,
      content: action.content,
      estimateSections: action.estimateSections,
      jobId: action.jobId,
      userId: action.userId
    }
    yield call(api.updateJobSiteEstimate, payload)
    yield put({ type: constants.JOB_SITE_ESTIMATE_UPDATE.SUCCESS, payload })
    yield call(jobSiteEstimatesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_ESTIMATE_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobSiteEstimate() {
  yield takeLatest(constants.JOB_SITE_ESTIMATE_UPDATE.ACTION, sagaUpdateJobSiteEstimate)
}

function* sagaDeleteJobSiteEstimate(action) {
  try {
    const payload = {
      estimate_id: action.estimateId
    }
    yield call(api.deleteJobSiteEstimate, payload)
    yield put({ type: constants.JOB_SITE_ESTIMATE_DELETE.SUCCESS, payload })
    yield call(jobSiteEstimatesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_ESTIMATE_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobSiteEstimate() {
  yield takeLatest(constants.JOB_SITE_ESTIMATE_DELETE.ACTION, sagaDeleteJobSiteEstimate)
}

function* getEstimateSections(action) {
  try {
    const payload = yield call(api.getEstimateSections, action.estimateId)
    yield put({ type: constants.GET_ESTIMATE_SECTIONS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ESTIMATE_SECTIONS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetEstimateSections() {
  yield takeLatest(constants.GET_ESTIMATE_SECTIONS.ACTION, getEstimateSections)
}

function* getEstimateItems(action) {
  try {
    const payload = yield call(api.getEstimateItems, action.estimateId)
    yield put({ type: constants.GET_ESTIMATE_ITEMS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ESTIMATE_ITEMS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetEstimateItems() {
  yield takeLatest(constants.GET_ESTIMATE_ITEMS.ACTION, getEstimateItems)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      estimateId: action.estimateId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_ESTIMATE_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { estimateId: action.estimateId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_ESTIMATE_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_ESTIMATE_ATTACHMENT.ACTION, uploadAttachments)
}

function* getAttachments(action) {
  try {
    const payload = yield call(api.getAttachments, action.estimateId)
    yield put({ type: constants.GET_ESTIMATE_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ESTIMATE_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_ESTIMATE_ATTACHMENTS.ACTION, getAttachments)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_ESTIMATE_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAttachments, { estimateId: action.estimateId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_ESTIMATE_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_ESTIMATE_ATTACHMENT_DESCRIPTION.ACTION,
    updateAttachmentDescription
  )
}

function* deleteAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      estimateId: action.estimateId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_ESTIMATE_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { estimateId: action.estimateId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_ESTIMATE_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachments() {
  yield takeLatest(constants.DELETE_ESTIMATE_ATTACHMENT.ACTION, deleteAttachment)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobSiteEstimates),

    fork(watchCreateJobSiteEstimate),
    fork(watchUpdateJobSiteEstimate),
    fork(watchDeleteJobSiteEstimate),

    fork(watchGetEstimateSections),
    fork(watchGetEstimateItems),

    fork(watchUploadAttachments),
    fork(watchGetAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchDeleteAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobSiteEstimateSaga.js